import { createBrowserHistory } from 'history';
import { isString } from 'lodash';
import resolvePath from './resolvePath';

// Mirrors the basename handling inside history, so a path that is already prefixed isn't prefixed twice
function stripBasename(path, basename) {
    if (!basename || path.indexOf(basename) !== 0) return path;

    const rest = path.substring(basename.length);
    if (rest === '') return '/';
    return rest.match(/^[/?#]/) ? rest : path;
}

export function setupHistory() {
    let basename = document.querySelector('base').getAttribute('href');
    try{
        basename = new URL(basename).pathname;
    } catch (err) {
        basename = basename.replace(/^\./, '');
    }
    // history drops the trailing slash internally; keep app.history.basename identical to what
    // history uses, so callers concatenating onto it don't end up with a double slash
    basename = basename.replace(/\/$/, '');

    app.history = createBrowserHistory({ basename: basename, forceRefresh: false });
    app.history.basename = basename;

    // location holds the basename but history prepends it again, so it has to come off first
    function resolveNextPath(path) {
        if (isString(path)) {
            if (path.match(/^\./)) {
                return resolvePath(stripBasename(location.pathname, basename), path);
            } else if (path.indexOf(location.origin) === 0) {
                return stripBasename(path.substring(location.origin.length), basename);
            }
        }
        return path;
    }

    let { push, replace } = app.history;

    app.history.push = (path, ...extra) => {
        const nextPath = resolveNextPath(path);
        // console.log('Navigation requested (PUSH):', path, nextPath);
        return push.apply(this, [nextPath, ...extra]);
    };

    app.history.replace = (path, ...extra) => {
        const nextPath = resolveNextPath(path);
        // console.log('Navigation requested (REPLACE):', path, nextPath);
        return replace.apply(this, [nextPath, ...extra]);
    };
}
